import { createVNode as _createVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("h3", null, "Default Template", -1)
const _hoisted_2 = /*#__PURE__*/_createVNode("p", null, " Select the default template to be assigned to new organizations. This setting will not apply to new organizations that sign up through Geotab or any third party. ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TemplateSelector = _resolveComponent("TemplateSelector")
  const _directive_loading = _resolveDirective("loading")

  return _withDirectives((_openBlock(), _createBlock("div", null, [
    _hoisted_1,
    _hoisted_2,
    _createVNode(_component_TemplateSelector, {
      modelValue: _ctx.setting.default_template_id,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.setting.default_template_id = $event))
    }, null, 8, ["modelValue"])
  ], 512)), [
    [_directive_loading, _ctx.fetchState !== _ctx.FetchStates.FETCHED]
  ])
}